import "./AccountDropDownComponent.scss";
import template from "./AccountDropDownComponent.html";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {AccountSource} from "../../../types/AccountSource";
import {Observable, ReplaySubject, Scheduler, Subject} from "rxjs";
import {AccountBriefRecord, AccountBriefRecords} from "../../../types/AccountBriefRecord";
import {AccountDropDownViewModel, AccountDropDownViewModels, buildModels} from "./models/AccountDropDownViewModel";
import {Consumer} from "../../../../types/GenericTypes";

export const AccountDropDown = "tfAccountDropDown";

export function accountDropDown(): IComponentOptions {
    return {
        template,
        bindings: {
            source: "<",
            hideSearchIcon: "<",
            hideArrowButton: "<",
        },
        controllerAs: "ctrl",
        controller: AccountDropDownComponentController
    };
}

export class AccountDropDownComponentController implements IOnInit, IOnDestroy {

    /** @input */
    public set source(source: AccountSource | null) {
        if (source != null) {
            this.source$.next(source);
        }
    }

    public hideSearchIcon: boolean | null;

    public hideArrowButton: boolean | null;

    private readonly source$ = new ReplaySubject<AccountSource>();

    public readonly models$ = new ReplaySubject<AccountDropDownViewModels>(1);

    public readonly selected$ = new ReplaySubject<AccountBriefRecord>(1);

    private readonly accounts$ = new ReplaySubject<AccountBriefRecords>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    public $onInit(): void {
        this.source$
            .takeUntil(this.destroyed$)
            .observeOn(Scheduler.async)
            .subscribe(this.watchSource());
        this.watchModelSources();
    }

    private watchSource(): Consumer<AccountSource> {
        const sourceChanged$ = new Subject<boolean>();
        return (source) => {
            sourceChanged$.next(true);
            source.accounts.subscribe((accounts) => this.accounts$.next(accounts));
            source.current.subscribe((current) => {
                if (current != null) {
                    this.selected$.next(current);
                }
            });
        };
    }

    private watchModelSources() {
        const selected$ = this.selected$.startWith(null);
        const source$ = Observable.combineLatest(this.accounts$, selected$);
        source$.takeUntil(this.destroyed$)
               .observeOn(Scheduler.async)
               .map(([accounts, selected]) => buildModels(accounts, selected))
               .subscribe((models) => this.models$.next(models));
    }

    public selectAccount(model: AccountDropDownViewModel) {
        this.source$
            .first()
            .takeUntil(this.destroyed$)
            .subscribe((source) => source.selectAccount(model.id));
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
